export default "__VITE_ASSET__BHmDnfzL__"